import $ from 'jquery';
import * as bootstrap from 'bootstrap';
require ('./common.js');
var RegistrationRules = {
	firstname: {
		required: true,
		minlength: 2
	},
	lastname: {
		required: true,
		minlength: 2
	},
	email: {
		required: true,
		email: true
	},
	phone: {
		required: true,
		number: true
	},
	address: {
		required: true,
		minlength: 5
	},
	city: {
		required: true,
		minlength: 2
	},
	province: {
		required: true
	},
	network: {
            required: true
        },
	zip: {
		required: true,
		number: true
	},
	cfpiva: {
		required: true
	},
	privacy: {
		required: true
	}
};
var DataRules = {
	firstname: {
    		required: true,
    		minlength: 2
    	},
    	lastname: {
    		required: true,
    		minlength: 2
    	},email: {
		required: true,
		email: true
	},
	phone: {
		required: true,
		minlength: 6
	},
    network: {
        required: true
    },
};
var LoginRules = {

	email: {
		required: true,
		email: true
	},
	password: {
		required: true,
		minlength: 6
	}
};

var ForgotRules = {
	email: {
		required: true,
		email: true
	}
};

$.urlParam = function (name) {
	var results = new RegExp('[\?&]' + name + '=([^]*)').exec(window.location.href);
	if (results == null) {
		return null;
	} else {
		return results[1] || 0;
	}
};

function removeGetParametersInUrl() {
	var uri = window.location.toString();
	if (uri.indexOf('?') > 0) {
		var clean_uri = uri.substring(0, uri.indexOf('?'));
		window.history.replaceState({}, document.title, clean_uri);
	}
}

function IsEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}

function resetFormFields(form)
{
	form.find('input')
		.not(':button, :submit, :reset, :hidden')
		.val('')
		.prop('checked', false)
		.prop('selected', false);
}

function resetResultContent(result)
{
	result.removeClass().html();
	$(result).hide();
}

function showConfirmationModal(modal, content)
{
	//$('.modal').modal('hide');
	/*alert(modal);*/
	if (content !== '') {
		$(modal)
			.find('#dynamicContent')
			.html(content);
	}
	/*const myModal = new bootstrap.Modal(document.getElementById(modal), {
		'keyboard': false,
		'backdrop':true
	});*/
	//alert(document.getElementById(modal));
	//myModal.open();
	$(modal)
		.modal({keyboard: false})
		.modal('show');
}


function validateFormWithRules(form, rules, result)
{
	result.html('');
	result.hide();

	form.validate({
		errorPlacement: function (error, element) {
			//
		},
		rules: rules,
		onsubmit: true,
		focusCleanup: true
	});

	if (!form.valid()) {
		var message = 'Ops, qualcosa non va! Il campo evidenziato ci risulta sbagliato. Prova a controllare.';
		result.html(message).show();
		return false;
	}

	return true;
}

function validateRequiredFields(inputs, result)
{
	var requiredEmpty = [];

	inputs.forEach(function(input) {
		if ($(input).val() == '') {
			requiredEmpty.push($(input));
		}
	});

	if (requiredEmpty.length) {
		requiredEmpty.forEach(function(element) {
			element.addClass('error');
		});

		result
			.addClass('alert-danger')
			.html('Ops, alcuni campi obbligatori non stati compilati.')
			.show();

		return false;
	}

	return true;
}
function validateNetworkField(form,  result)
{
	if (!form.find('input[name="network"]:checked').val()){
		result
			.addClass('alert-danger')
			.html('Ops, per completare il processo devi selezionare la tipologia di attività per cui lavori.')
			.show();

		return false;
	}

	return true;
}
function validatePrivacyField(form, id, result)
{
	if (!form.find(id).is(':checked')){
		result
			.addClass('alert-danger')
			.html('Ops, per completare il processo devi accettare l’Informativa sul trattamento dei dati.')
			.show();

		return false;
	}

	return true;
}

function validateEmailField(form, id, result)
{
	if (IsEmail(form.find(id).val()) !== true) {
		result
			.addClass('alert-danger')
			.html('Ops, per completare il processo devi inserire una e-mail formalmente valida.')
			.show();

		return false;
	}

	return true;
}

$(document).ready(function () {

	var body = $('body');

	// ??
	if ($.urlParam('product_id')) {
		$.ajax({
			method: "POST",
			url: "/site/additemtochart",
			data: {product_id: getCookie("PID"),product_quantity: getCookie("PQ")}
		})
			.done(function( msg ) {
				$.ajax({
					method: "POST",
					url: "/site/quickchart",
					data: {}
				})
					.done(function( msg ) {
						$("#contentchart ").html(msg);
						$("#contentchart").addClass('hover');
						setTimeout(function(){  $("#contentchart").removeClass('hover') }, 3000);
					});

			});
		var uri = window.location.toString();
		if (uri.indexOf("?") > 0) {
			var clean_uri = uri.substring(0, uri.indexOf("?"));
			window.history.replaceState({}, document.title, clean_uri);
		}
	}

	//$('#contentchart').addClass('hover');

	if ($.urlParam('registration')) {

		removeGetParametersInUrl();

		$('#modal-confirm-registration')
			.modal({keyboard: false})
			.modal('show');
	}

	if ($.urlParam('show_welcome_message')) {

		removeGetParametersInUrl();

	}

	// Password toggle visibility
	$(document).on('click', '.passwordToggle', function (ev) {
		ev.preventDefault();

		var passwordField = $(this).siblings('#password');

		$(this).toggleClass('password-hidden');

		if (passwordField.attr('type') === 'password') {
			passwordField.attr('type', 'text');
		} else {
			passwordField.attr('type', 'password');
		}
	});
	//TODO Commento questo metodo perchè dovrebbe attivarsi da solo tramite bootstrap 5
	// Attivazioni modali
	/*body.on('click', '.js-show-modal', function (ev) {
		ev.preventDefault();
		var modal = $(this).attr('data-show-modal');

		if ($(this).hasClass('js-access')) {
			var reference = $(this).attr('data-ref-modal');

			$(modal)
				.removeClass('js-reference-login')
				.removeClass('js-reference-register')
				.addClass('js-reference-'+reference);
		}

		showConfirmationModal(modal);
	});*/
	$('input[name="network"] + label' ).hover(
		function() {
			$( this ).parent().find( '.ctooltip').addClass("hover");
		}, function() {
			$( this ).parent().find('.ctooltip').removeClass("hover");
		}
	);

	body.on('click', '.js-registerbtn', function (ev) {
		ev.preventDefault();

		var form = $(this).closest('form');
		var inputsRequired = form.find('input[required]').toArray();
		var result = form.find('#result');
		var reloadTo = form.attr('data-reload');

		if (validateFormWithRules(form, RegistrationRules, result) !== true) {
			return false;
		}

		if (validateRequiredFields(inputsRequired, result) !== true) {
			return false;
		}

		if (validateNetworkField(form, result) !== true) {
			return false;
		}
		if (validatePrivacyField(form, '#privacy', result) !== true) {
			return false;
		}
		if (validateEmailField(form, '#remail', result) !== true) {
			return false;
		}

		const RegisterForm = {
			RegisterForm: {
				address: form.find('#address').val(),
				email: form.find('#remail').val(),
				firstname: form.find('#firstname').val(),
				lastname: form.find('#lastname').val(),
				company: form.find('#company').val(),
				zip: form.find('#zip').val(),
				phone: form.find('#phone').val(),
				province: form.find('#province').val(),
				city: form.find('#city').val(),
				network: form.find('input[name="network"]:checked').val(),
				cfpiva: form.find('#cfpiva').val()
			}
		};

		$.ajax({
			method: 'POST',
			url: '/site/registeruser',
			data: RegisterForm
		})
		.done(function (data) {

			if (data.result == false) {

				result
					.html(data.msg)
					.show();

				return false;

			}
			window.location.href = reloadTo+'?registration=true&show_welcome_message=registration';

		});
	});

	body.on('click', '.js-after-confirm-registration', function(ev) {
		window.location.href = '/site/register?newuser=1';
	});

	body.on('click', '.js-forgotbtn', function (ev) {
		ev.preventDefault();

		var form = $(this).closest('form');
		var inputsRequired = form.find('input[required]').toArray();
		var result = form.find('#result');

		if (validateFormWithRules(form, ForgotRules, result) !== true) {
			return false;
		}

		if (validateRequiredFields(inputsRequired, result) !== true) {
			return false;
		}

		if (validateEmailField(form, '#femail', result) !== true) {
			return false;
		}

		var ForgotForm = {
			ForgotForm: {
				email: form.find('#femail').val()
			}
		};

		$.ajax({
			method: 'POST',
			url: '/site/forgotpwd',
			data: ForgotForm
		})
		.done(function (data) {

			if (data.result == false) {
				result
					.addClass('alert-danger')
					.html(data.msg)
					.show();

				return false;
			}

			resetFormFields(form);

			resetResultContent(result);
			$("#modal-forgot").modal('hide');
			showConfirmationModal('#modal-forgot-sent');

		});
	});

	body.on("focus", "#itemform input", function () {
		$("#itemform input").removeClass("error");
		$("#itemform #result").hide();
	});

	body.on('click', '.js-modifybtn', function (ev) {
		ev.preventDefault();

		var form = $(this).closest('form');
		var inputsRequired = form.find('input[required]').toArray();
		var result = form.find('#result');
		var confirmationModal = form.attr('data-confirmation-modal');

		if (validateFormWithRules(form, RegistrationRules, result) !== true) {
			return false;
		}

		if (validateRequiredFields(inputsRequired, result) !== true) {
			return false;
		}

		var RegisterForm = {
			RegisterForm: {
				address: form.find("#address").val(),
				email: form.find("#remail").val(),
				firstname: form.find("#firstname").val(),
				lastname: form.find("#lastname").val(),
				company: form.find("#company").val(),
				zip: form.find("#zip").val(),
				phone: form.find("#phone").val(),
				province: form.find("#province").val(),
				city: form.find("#city").val(),
				cfpiva: form.find("#cfpiva").val()
			}
		};

		$.ajax({
			method: "POST",
			url: "/site/modifyuser",
			data: RegisterForm
		})
		.done(function (data) {
			if (data.result == false) {
				result
					.addClass("alert-danger")
					.html(data.msg)
					.show();
			} else {

				var content = '';

				if (form.attr('data-confirmation-title') !== '') {
					content += '<h2>'+form.attr('data-confirmation-title')+'</h2>';
					content += '<p>'+form.attr('data-confirmation-text')+'</p>';
				}

				resetResultContent(result);
				$("#modal-forgot").modal('hide');
				showConfirmationModal(confirmationModal, content);

			}
		});
	});

	body.on( 'click', '.js-changepwd', function(ev) {
		ev.preventDefault();

		var form = $(this).closest('form');
		var result = form.find('#result');

		var ChangeForm = {
			ChangeForm: {
				userid: $("#changeform #userid").val(),
				auth_key:$("#changeform #auth_key").val()
			}
		};

		$.ajax({
			method: "POST",
			url: "/site/sendnewpwd",
			data: ChangeForm
		})
			.done(function( data ) {

				if(data.result != true) {
					result
						.removeClass()
						.addClass("alert-danger")
						.html(data.msg)
						.show();

					return false;
				}

				resetResultContent(result);

				removeGetParametersInUrl();
				$("#modal-reset").modal('hide');
				showConfirmationModal(data.modal);

			});
	});

        body.on('click', '.js-notconfirmdatabtn', function (ev) {
			/*notmodifyuseremail*/
        		ev.preventDefault();
            $.ajax({
                method: "POST",
                url: "/site/refuseuseremail",
                data: {},
            })
                .done(function (data) {
                    if (data.result == false) {
                        result
                            .addClass('alert-danger')
                            .html(data.msg)
                            .show();
                    } else {
                        window.location.reload();
                    }
			});
        		});
        body.on('click', '.js-confirmdatabtn', function (ev) {
		ev.preventDefault();

		var form = $(this).closest('form');
		var result = form.find('#result');
		var inputsRequired = form.find('input[required]').toArray();
		var reloadTo = form.attr('data-reload');

		if (validateFormWithRules(form, DataRules, result) !== true) {
			return false;
		}
			if (validateNetworkField(form, result) !== true) {
				return false;
			}
		if (validateRequiredFields(inputsRequired, result) !== true) {
			return false;
		}

		$.ajax({
			method: "POST",
			url: "/site/modifyuseremail",
			data: {email: form.find("#email").val(), phone: form.find("#phone").val(), network: form.find('input[name="network"]:checked').val(), firstname: form.find("#firstname").val(), lastname: form.find("#lastname").val()},
		})
			.done(function (data) {
				if (data.result == false) {
					result
						.addClass('alert-danger')
						.html(data.msg)
						.show();
				} else {

					window.location.reload();

				}
			});
	});
	body.on('click', '.js-loginbtn', function (ev) {

		ev.preventDefault();

		var form = $(this).closest('form');
		var result = form.find('#result');
		var inputsRequired = form.find('input[required]').toArray();
		var reloadTo = form.attr('data-reload');

		if (validateFormWithRules(form, LoginRules, result) !== true) {
			return false;
		}

		if (validateRequiredFields(inputsRequired, result) !== true) {
			return false;
		}

		var LoginForm = {
			LoginForm: {
				username: form.find("#email").val(),
				password: form.find("#password").val(),
				rememberMe: 0
			}
		};


		$.ajax({
			method: "POST",
			url: "/site/loginfromajax",
			data: LoginForm
		})
			.done(function (data) {
				if (data.result == false) {
					result
						.addClass('alert-danger')
						.html(data.msg)
						.show();
				} else {
					if (checkCookie("PID")) {

								var url = window.location.href;

								if (url.indexOf('?') > -1) {
									url += '&product_id=' + getCookie("PID")+"&product_quantity="+ getCookie("PQ");
								} else {
									url += '?product_id=' + getCookie("PID")+"&product_quantity="+ getCookie("PQ");
								}
								window.location.href = url;

					} else {
						/*Giurie Giurati Supergiurie  eregie vanno direttamente al backend*/
						if(data.role==4 || data.role==9){
							window.location.href = "/";
						}else if(  data.role==5 || data.role==6 || data.role==7) {
							window.location.href = "/item";
						}else if(data.role==7){
							window.location.href = "/item/giuria/";
						}else{
							window.location.href = reloadTo;
						}
						//
					}
				}
			});
	});

	body.on('click', '.js-passwordbtn', function (ev) {
		ev.preventDefault();

		var form = $(this).closest('form');
		var result = form.find('#result');
		const isAllowedPassword = window.isAllowedPassword;

		if ($("#memail").val() != '' && !IsEmail($("#memail").val())) {
			result
				.addClass("alert-danger")
				.html('Inserire una email valida')
				.show();

			return false;
		}

		if ($("#memail").val() != $("#cmail").val() && $("#memail").val() != "") {
			result
				.addClass("alert-danger")
				.html('Le email non coincidono')
				.show();

			return false;
		}

		if ($("#mpassword").val() != $("#cpassword").val() && $("#mpassword").val() != "") {
			result
				.addClass("alert-danger")
				.html('Le password non coincidono')
				.show();

			return false;
		}

		if (!isAllowedPassword($("#mpassword").val()) && $("#mpassword").val() != "") {
			result
				.addClass("alert-danger")
				.html('La password deve essere lunga 8 caratteri e contenere almeno una Maiuscola un numero e un carattere speciale')
				.show();

			return false;
		}

		$.ajax({
			method: "POST",
			url: "/site/modifypassword",
			data: {
				'password': $("#mpassword").val(),
				'email': $("#memail").val()
			}
		})
		.done(function (data) {
			if (data.result == false) {
				result
					.addClass("alert-danger")
					.html(data.msg)
					.show();
			} else {
				result
					.removeClass("alert-danger")
					.addClass("alert-success")
					.html("Credenziali modificate con successo")
					.show();

				$("#emailutente").text(data.email);
				$("#memail").val('');
				$("#cmail").val('');
				$("#mpassword").val('');
				$("#cpassword").val('');
			}
		});
	});
});